import React from "react";
import { useContext } from "react";
import FreightForm from "./freightForm";
import FreightDetail from "./freightDetail";
import SectionContext from "../../../contexts/SectionContext";
import ModalContext from "../../../contexts/ModalContext";

interface RouterModalProps {
    content: "form"|"detail"
}


const FreightContent = ()=>{
    const { setModalActive, modalSection } = useContext(ModalContext)

    if(modalSection.includes("Detail")){
        return(
            <FreightDetail/>
           
        )
    }else if(modalSection.includes("Form")){
        return(
            <FreightForm/>
        )
    }
}

export default FreightContent